import React, { useState, useEffect } from "react";
import axios from 'axios';
import { FaCheck } from "react-icons/fa";
import ToastNotification from "../../components/ToastNotification/ToastNotification";
function SubscriptionReport() {
  const [searchTerm, setSearchTerm] = useState('');
  const [data, setData] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedPlan, setSelectedPlan] = useState("");
  const [search, setSearch] = useState("");
  const [previewImg, setPreviewImg] = useState(null);
  const [confirmModal, setConfirmModal] = useState({
    show: false,
    data: null
  });
  const [toast, setToast] = useState({
    show: false,
    message: '',
    bg: 'success'
  });
  const showToast = (msg, bg = 'success') => {
    setToast({
      show: true,
      message: msg,
      bg
    });
  };
  const fetchSubHistory = async () => {
    try {
      const res = await axios.get(`https://api.sweepydo.in/fetch-subscription-history?from=${fromDate}&to=${toDate}`);
      setData(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (fromDate && toDate) {
      fetchSubHistory();
    }
  }, [fromDate, toDate]);
  useEffect(() => {
    fetchSubHistory();
  }, []);
  const filtered = data.filter(item => {
    const searchValue = searchTerm.toLowerCase();
    const matchSearch = Object.values(item).join(" ").toLowerCase().includes(searchValue);
    const matchPlan = selectedPlan ? item.sub_name === selectedPlan : true;
    return matchSearch && matchPlan;
  });
  const planOptions = [...new Set(data.map(item => item.sub_name))];
  const handleConfirmUpdate = async () => {
    const item = confirmModal.data;
    try {
      await axios.put(`https://api.sweepydo.in/update-plan-transaction/${item.id}`, {
        status: "Success"
      });
      showToast("Transaction updated successfully", "success");

      // 🔥 update UI instantly
      setData(prev => prev.map(d => d.id === item.id ? {
        ...d,
        status: "Success"
      } : d));
    } catch (error) {
      console.error(error);
      showToast("Failed to update", "danger");
    }

    // close modal
    setConfirmModal({
      show: false,
      data: null
    });
  };
  return <div className="container-fluid mt-1 p-4" style={{
    minHeight: "100vh"
  }}>


         <h2 className="text-center mb-4 text-white">Subscription Plan Report </h2>
           <ToastNotification show={toast.show} message={toast.message} bg={toast.bg} onClose={() => setToast({
      ...toast,
      show: false
    })} />
     <div style={{
      background: "var(--black)",
      borderRadius: "12px",
      padding: "15px"
    }}>
          <div className="d-flex justify-content-between align-items-center flex-wrap mb-3 ">


  <div style={{
          minWidth: "250px"
        }}>
 <input type="text" className="form-control p-2 "
          // style={{ maxWidth: "300px" }}
          placeholder="Search plan..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} style={{
            background: "#0f172a",
            color: "#fff",
            border: "1px solid #334155"
          }} />
  </div>
           

  {/* RIGHT SIDE → Filters */}
  <div className="d-flex align-items-center gap-3 flex-wrap">

    {/* From Date */}
    <input type="date" className="form-control" value={fromDate} onChange={e => setFromDate(e.target.value)} style={{
            width: "180px",
            background: "#0f172a",
            color: "#fff",
            border: "1px solid #334155"
          }} />

    {/* To Date */}
    <input type="date" className="form-control" value={toDate} onChange={e => setToDate(e.target.value)} style={{
            width: "180px",
            background: "#0f172a",
            color: "#fff",
            border: "1px solid #334155"
          }} />

 <select className="form-control" value={selectedPlan} onChange={e => setSelectedPlan(e.target.value)} style={{
            width: "200px",
            background: "#0f172a",
            color: "#fff",
            border: "1px solid #334155"
          }}>
  <option value="">All Plans</option>
  {planOptions.map((plan, idx) => <option key={idx} value={plan}>
      {plan}
    </option>)}
</select>

  </div>


        
          </div>


          <div className='table-responsive '>
            <table style={{
          width: "100%",
          borderCollapse: "collapse",
          color: "#fff"
        }}>
              <thead>
                <tr style={{
              backgroundColor: "var(--black2)"
            }}>
                  <th style={{
                padding: "18px",
                textAlign: "center"
              }}>SN</th>
                  <th style={{
                padding: "18px",
                textAlign: "center"
              }}>User Name</th>
                  <th style={{
                padding: "18px",
                textAlign: "center"
              }}>Plan Name</th>
                  <th style={{
                padding: "18px",
                textAlign: "center"
              }}>Amount</th>
                   <th style={{
                padding: "18px",
                textAlign: "center"
              }}>Coin</th>
                  <th style={{
                padding: "18px",
                textAlign: "center"
              }}>Start Date </th>
                  <th style={{
                padding: "18px",
                textAlign: "center"
              }}>End Date</th>
                     <th style={{
                padding: "18px",
                textAlign: "center"
              }}>View Image</th>
                     <th style={{
                padding: "18px",
                textAlign: "center"
              }}>Payment Status</th>
                        <th style={{
                padding: "18px",
                textAlign: "center"
              }}>Payment ID</th>
                            <th style={{
                padding: "18px",
                textAlign: "center"
              }}>Action</th>
                </tr>
              </thead>
              <tbody>

                {filtered.map((s, i) => <tr key={s.id} style={{
              backgroundColor: "var(--black)",
              borderBottom: "1px solid rgba(255,255,255,0.06)",
              transition: "0.3s"
            }} onMouseEnter={e => {
              e.currentTarget.style.backgroundColor = "var(--black2)";
            }} onMouseLeave={e => {
              e.currentTarget.style.backgroundColor = "var(--black)";
            }}>
                    <td style={{
                padding: "18px",
                textAlign: "center"
              }}> {i + 1}</td>
                    <td style={{
                padding: "18px",
                textAlign: "center"
              }}>{s.user_name} </td>
                    <td style={{
                padding: "18px",
                textAlign: "center"
              }}>{s.sub_name || "Custom Plan"} </td>
                    <td style={{
                padding: "18px",
                textAlign: "center"
              }}>{s.amount} </td>
                      <td style={{
                padding: "18px",
                textAlign: "center"
              }}>{s.coins} </td>
                    <td style={{
                padding: "18px",
                textAlign: "center"
              }}>{s.rec_date} </td>
                      <td style={{
                padding: "18px",
                textAlign: "center"
              }}>{s.end_date} </td>
                       <td style={{
                textAlign: "center"
              }}>
  {s.pay_img ? <button className="btn btn-sm btn-info" onClick={() => setPreviewImg(`https://api.sweepydo.in/uploads/${s.pay_img}`)}>
      View
    </button> : "No Image"}
</td>
                   <td style={{
                padding: "18px",
                textAlign: "center"
              }}>{s.status} </td>
                    <td style={{
                padding: "18px",
                textAlign: "center"
              }}>{s.payment_id} </td>
                    <td style={{
                padding: "18px",
                textAlign: "center"
              }}>
                       <button className="btn btn-sm btn-success" title="Mark as Verify" disabled={s.status?.toLowerCase().includes("success")} onClick={() => setConfirmModal({
                  show: true,
                  data: s
                })}>
                         <FaCheck />
                       </button>

                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

{previewImg && <div className="modal fade show" style={{
        display: "block",
        background: "rgba(0,0,0,0.5)"
      }}>
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">

        <div className="modal-header">
          <h5 className="modal-title">Payment Preview</h5>
          <button className="btn-close" onClick={() => setPreviewImg(null)}></button>
        </div>

        <div className="modal-body text-center">
          <img src={previewImg} alt="preview" style={{
                maxWidth: "75%"
              }} />
        </div>

      </div>
    </div>
  </div>}

{confirmModal.show && <div className="modal fade show" style={{
        display: "block",
        background: "rgba(0,0,0,0.6)"
      }}>
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content bg-dark text-white border border-secondary">

        {/* Header */}
        <div className="modal-header">
          <h5 className="modal-title text-warning">
            Confirm Payment
          </h5>

          <button className="btn-close btn-close-white" onClick={() => setConfirmModal({
                show: false,
                data: null
              })}></button>
        </div>

        {/* Body */}
        <div className="modal-body text-center">

          <p>
            Are you sure you want to update the transaction for this user?
          </p>

          <p className="fw-bold  text-info">
            {confirmModal.data?.user_name}
          </p>

         

        </div>

        {/* Footer */}
        <div className="modal-footer justify-content-center">

          <button className="btn btn-secondary px-4" onClick={() => setConfirmModal({
                show: false,
                data: null
              })}>
            Cancel
          </button>

          <button className="btn btn-success px-4" onClick={handleConfirmUpdate}>
            Confirm
          </button>

        </div>

      </div>
    </div>
  </div>}

        </div>
    </div>;
}
export default SubscriptionReport;
